import { render } from "./DeleteIcon.vue?vue&type=template&id=41a63994"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DeleteIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41a63994"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41a63994', __exports__)) {
    api.reload('41a63994', __exports__)
  }
  
  module.hot.accept("./DeleteIcon.vue?vue&type=template&id=41a63994", () => {
    api.rerender('41a63994', render)
  })

}


export default __exports__